// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2NOaU","left":"StickyBox_left__1KM68","right":"StickyBox_right__yjnFf"};